import { Link } from "react-router-dom";
import { archives } from "@/mocks/archive";
import ArchiveCard from "@/components/feature/ArchiveCard";

export default function FeaturedArchives() {
  const [featured, ...rest] = archives;
  const gridItems = rest.slice(0, 3);

  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs tracking-[0.22em] text-primary-600">FEATURED DOSSIERS</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            本周重新校验的档案
          </h2>
        </div>
        <Link
          to="/archive"
          className="inline-flex items-center gap-1 text-sm text-foreground-800 hover:text-primary-600 transition-colors whitespace-nowrap"
        >
          全部 312 篇档案
          <i className="ri-arrow-right-up-line"></i>
        </Link>
      </div>

      <article className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden border border-background-300 bg-background-100">
        <Link to={`/archive/${featured.slug}`} className="block h-64 lg:h-auto lg:min-h-[360px] overflow-hidden">
          <img
            src={featured.cover}
            alt={`${featured.title} 档案头图`}
            title={`${featured.title} - 黑料网红黑历史考古`}
            className="w-full h-full object-top hover:scale-[1.03] transition-transform duration-500"
          />
        </Link>
        <div className="p-6 md:p-8 flex flex-col justify-center">
          <div className="flex flex-wrap items-center gap-2 mb-4">
            <span className="px-2.5 py-1 rounded-md bg-primary-500 text-background-50 text-[11px]">
              编辑推荐
            </span>
            <span className="px-2.5 py-1 rounded-md bg-accent-100 text-accent-900 text-[11px]">
              {featured.category}
            </span>
          </div>
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-snug mb-3">
            <Link to={`/archive/${featured.slug}`} className="hover:text-primary-600 transition-colors">
              {featured.title}
            </Link>
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed mb-5">{featured.summary}</p>
          <div className="flex flex-wrap items-center gap-3 text-xs text-foreground-500 mb-6">
            <span>存档日期 {featured.date}</span>
            <span>· 全文 {featured.readMinutes} 分钟</span>
            <span>· 围观 {featured.views}</span>
          </div>
          <Link
            to={`/archive/${featured.slug}`}
            className="self-start px-5 py-2.5 rounded-md bg-foreground-950 text-background-50 text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap"
          >
            阅读这份档案
          </Link>
        </div>
      </article>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {gridItems.map((item) => (
          <ArchiveCard key={item.slug} archive={item} />
        ))}
      </div>
    </section>
  );
}